@if (menuData?.activeUserLevels.isEnterprise && enterprise$ | async) {
  <div class="main-nav__item">
    <portal-context-switcher
      #switcher
      [allowPreviousNext]="false"
      [disabled]="isAllowedToSwitch === false || isOnEnterpriseLevel === false"
      [entries]="entries$ | async"
      [placeholder]="'enterprise.breadcrumbSwitcher.placeholder' | translate"
      (valueChanged)="trigger($event)"
      initialRoute="enterprise"
      switchParameter="enterpriseId"
    >
      <ng-template>
        <div>
          <span class="main-nav-expanded--visible">
            {{ 'menu.context.enterprise' | portalTranslate }}
          </span>
          <i class="far fa-industry main-nav__item-icon main-nav-expanded--hidden"></i>
          <i class="enterprise-switcher__toggle-icon far fa-angle-down ms-1 main-nav-expanded--hidden"></i>
        </div>
        <div class="enterprise-switcher__name-container" role="button">
          <span class="enterprise-switcher__name">{{ menuData.enterpriseId }}</span>
          <i class="enterprise-switcher__toggle-icon far fa-angle-down ms-1 main-nav-expanded--visible"></i>
        </div>
        <div class="enterprise-switcher__description main-nav-expanded--visible">
          {{ (enterprise$ | async)?.c5.description }}
        </div>
      </ng-template>
    </portal-context-switcher>
  </div>
}
